const ctx = document.createElement('canvas').getContext('2d');

export const checkChildPosToOuterTransform = (x, y, trans) => {
  let res = [x,y];
  if (trans) {
    if (trans.angle) {
      if (trans.angle === 90) {
        res = [y, -x];
      } else if (trans.angle === 180) {
        res = [-x, -y];
      } else if (trans.angle === 270) {
        res = [-y, x];
      }
    }
    if (trans.mirror_x) {
      res = [-res[0], res[1]];
    }
    if (trans.mirror_y) {
      res = [res[0], -res[1]];
    }
  }
  return res;
};

export const arcPointsToSvgPath = (pa, pb, pc) => {
  // start_point, point_on_the_arc, end_point
  const x12 = (pa.x - pb.x);
  const x13 = (pa.x - pc.x);
  const y12 = (pa.y - pb.y);
  const y13 = (pa.y - pc.y);
  const y31 = (pc.y - pa.y);
  const y21 = (pb.y - pa.y);
  const x31 = (pc.x - pa.x);
  const x21 = (pb.x - pa.x);
 
  const sx13 = Math.pow(pa.x, 2) - Math.pow(pc.x, 2);
  const sy13 = Math.pow(pa.y, 2) - Math.pow(pc.y, 2);
  const sx21 = Math.pow(pb.x, 2) - Math.pow(pa.x, 2);
  const sy21 = Math.pow(pb.y, 2) - Math.pow(pa.y, 2);

  const f = ((sx13)*(x12)+(sy13)*(x12)+(sx21)*(x13)+(sy21)*(x13))/(2*((y31)*(x12)-(y21)*(x13)));
  const g = ((sx13)*(y12)+(sy13)*(y12)+(sx21)*(y13)+(sy21)*(y13))/(2*((x31)*(y12)-(x21)*(y13)));
  const c = -(Math.pow(pa.x, 2)) - Math.pow(pa.y, 2) - 2 * g * pa.x - 2 * f * pa.y;

  const h = -(g);
  const k = -(f);
  const sqr_of_r = h * h + k * k - c;
  const r = isNaN(sqr_of_r) ? 0 : Math.round(Math.sqrt(sqr_of_r) * 1000) / 1000;
  const a = Math.pow(pb.x-pa.x,2) + Math.pow(pb.y-pa.y,2);
  const b = Math.pow(pb.x-pc.x,2) + Math.pow(pb.y-pc.y,2);
  const cc = Math.pow(pc.x-pa.x,2) + Math.pow(pc.y-pa.y,2);
  const angle = Math.acos((a+b-cc) / Math.sqrt(4*a*b));

  //large arc flag
  const laf = Number((Math.PI/2 >= angle));

  //sweep flag
  const saf = Number(!((pb.x - pa.x) * (pc.y - pa.y) - (pb.y - pa.y) * (pc.x - pa.x) < 0));
  return ['M', pa.x, pa.y, 'A', r, r, 0, laf, saf, pc.x, pc.y].join(' ')
};

export const measureText = (str, font) => {
  ctx.font = font;
  return ctx.measureText(str);
};

export const measureTextWidth = (str, font) => {
  return measureText(str, font).width;
};
